/**
 * Determines if a content type is editable (text-based) or not
 * @param contentType - The MIME content type string
 * @returns true if the content type is editable, false otherwise
 */
export const isEditableContentType = (contentType: string): boolean => {
  if (!contentType) return true // Default to editable if no content type

  const lowerContentType = contentType.toLowerCase()

  // Non-editable content types
  const nonEditableTypes = [
    'application/octet-stream', // Binary
    'application/pdf', // PDF
    'application/zip', // ZIP archives
    'application/x-zip-compressed',
    'application/x-rar-compressed',
    'application/x-7z-compressed',
    'application/x-tar',
    'application/gzip',
  ]

  // Non-editable content type prefixes
  const nonEditablePrefixes = [
    'image/', // All image types
    'video/', // All video types
    'audio/', // All audio types
    'application/vnd.', // Most Microsoft Office and other proprietary formats
  ]

  // Check exact matches
  if (nonEditableTypes.includes(lowerContentType)) {
    return false
  }

  // Check prefixes
  for (const prefix of nonEditablePrefixes) {
    if (lowerContentType.startsWith(prefix)) {
      return false
    }
  }

  // Default to editable for text-based and other common editable types
  return true
}
